import axios from 'axios';

export const getItemDefaultNotes = () =>
  axios
    .post('/api/get-default-item-notes', {
      op: 'list',
      convert: true,
    })
    .then(response => response.data)
    .catch(error => ({ success: false }));



// WEBPACK FOOTER //
// ./src/components/confirmDialog/_api.js